<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/baseContent/friendLinks' }"
          >链接列表
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">链接信息</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">配置友情链接</span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form
          :model="friendLink"
          label-width="120px"
          class="font-weight-bold w-75"
        >
          <el-form-item label="链接名称">
            <el-input
              v-model="friendLink.friendLinkName"
              placeholder="请输入链接名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接地址">
            <el-input
              v-model="friendLink.friendLinkUrl"
              placeholder="请输入链接名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接图标">
            <el-input
              v-model="friendLink.friendLinkIcon"
              autocomplete="off"
              placeholder="链接图标URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg"
                ref="friendLinkUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸48*48像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail text-muted"
                :src="friendLink.friendLinkIcon"
                :preview-src-list="[friendLink.friendLinkIcon]"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitBannerForm(friendLink)"
              >立即提交
            </el-button>
            <el-button @click="cancelSubmitForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import ImgUpload from "../../components/common/ImgUpload";
export default {
  name: "FriendLinkForm",
  data() {
    // noinspection JSUnresolvedVariable
    return {
      friendLinkId: this.$route.params.friendLinkId,
      friendLink: {
        friendLinkIcon: ""
      }
    };
  },
  components: {
    ImgUpload
  },
  mounted() {
    if (this.friendLinkId !== 0) {
      this.getFriendLinkById();
    }
  },
  methods: {
    getFriendLinkById() {
      this.axios
        .get("/friendLink/getFriendLinkById", {
          params: {
            friendLinkId: this.friendLinkId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.friendLink = resp.data.data;
          }
        });
    },
    uploadImg() {
      this.friendLink.friendLinkIcon = this.$refs.friendLinkUpload.url;
    },
    cancelSubmitForm() {
      this.$router.push({ name: "FriendLinks" }).catch();
    },
    submitBannerForm(friendLink) {
      this.axios
        .post("/friendLink/addOrPhotoFriendLink", {
          friendLinkId: friendLink.friendLinkId,
          friendLinkName: friendLink.friendLinkName,
          friendLinkIcon: friendLink.friendLinkIcon,
          friendLinkUrl: friendLink.friendLinkUrl
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "FriendLinks" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
